import RegisterPage from './RegisterPage-redux';

export default RegisterPage;
